//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VipIcon from '@tencent/vft-ui/src/VipIcon/VipIcon.vue';
import { PropertyBelong } from './util';
import awardAndShareMixin from './awardAndShareMixin';
import cookie from '@tencent/vft-common/cookie';
export default {
  mixins: [awardAndShareMixin],
  components: {
    VipIcon: VipIcon
  },
  props: ['awardList', 'eggImg', 'showNum', 'isFromPengDan'],
  data: function data() {
    return {
      currentIndex: 0,
      PropertyBelong: PropertyBelong,
      vuid: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    var swiper = new Swiper('.mod_award.swiper-container', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      on: {
        slideChange: function slideChange() {
          _this.currentIndex = swiper.realIndex;
        }
      }
    });
    this.$on('hook:beforeDestroy', function () {
      swiper.destroy();
    });
    this.vuid = cookie.get('vuserid');
  },
  computed: {
    currentItem: function currentItem() {
      return this.awardList[this.currentIndex];
    },
    isStarCode: function isStarCode() {
      return this.currentItem.other.type === 5;
    },
    // 奖品下方只展示一个人头像昵称
    oneUser: function oneUser() {
      if (this.isStarCode) {
        return this.currentItem.my;
      } else if (this.currentItem.property_belong === PropertyBelong.Guest) {
        return this.currentItem.my;
      } else if (this.currentItem.property_belong === PropertyBelong.Master) {
        return this.currentItem.other;
      }

      return false;
    },
    isMoneyAward: function isMoneyAward() {
      if (this.currentItem.property_belong === PropertyBelong.Normal) {
        return this.isCash(this.currentItem.my);
      } else if (this.currentItem.property_belong === PropertyBelong.Guest) {
        return this.isCash(this.currentItem.my) || this.isCash(this.currentItem.other);
      } else if (this.currentItem.property_belong === PropertyBelong.Master) {
        return false;
      } else if (this.currentItem.property_belong === PropertyBelong.Exchange) {
        return this.isCash(this.currentItem.my);
      }
    }
  },
  methods: {
    hide: function hide() {
      this.$emit('hide');
    },
    share: function share() {
      this.$emit('share', this.awardList[this.currentIndex]);
    },
    toAsset: function toAsset() {
      this.rootOpenUrl('//film.qq.com/weixin/v3/asset/index.html#award');
    },
    toMyAward: function toMyAward() {
      this.$emit('hide');
      var myRecord = document.getElementById('mod_my_record');

      if (myRecord) {
        window.scrollTo(0, myRecord.getBoundingClientRect().top + window.scrollY - 100);
      }
    }
  }
};